import * as React from 'react';
import { Props, State } from '@src/components/Proto';
import { FleetSearch, AverageData, BatteryList } from '../index';

// typing
interface LocalProps extends Props {
    getSearch: string;
    getAvgdata: string;
    getList: string;
}
interface LocalState extends State {
    filters?: any;
}

// component
export class Wrapper extends React.Component<LocalProps, LocalState> {
    search(filters) {
        this.setState({
            filters: {
                ...filters,
                time: Date.now()
            }
        });
    }

	render() {
        let filters;
        if (this.state) {
            filters = this.state.filters;
        }
		return (
            <>
                <FleetSearch cpt="FleetSearchLists" get={this.props.getSearch} filters={filters} onSearch={(filters) => this.search(filters)} />
                <AverageData cpt="FleetAverageData" get={this.props.getAvgdata} filters={filters}  />
                <BatteryList cpt="FleetBatteryList" get={this.props.getList} urlIndex={this.props.getList} filters={filters} onBattery={this.props.onBattery} />
            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Fleet/Wrapper.tsx